<template>
  <model-form
    :model="modifierSet"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-center">
        <model-form-input
          field="name"
          class="col-10"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
        <model-form-checkbox
          field="printingOptions.print_name"
          value-type="Boolean"
          class="col-2 q-pb-md"
          label="Print Name"
        >
          <q-tooltip>
            Prints the modifier set name along with the modifier name on prep slips.
          </q-tooltip>
        </model-form-checkbox>
      </div>
      <div class="row q-col-gutter-sm items-center">
        <model-form-checkbox
          field="availableOnline"
          class="col-3 q-pb-md"
          label="Available Online"
          :rules="[val => !val || $_.some(modifierSet.modifiers.data, 'availableOnline') || 'At least one modifier must be available online']"
        >
          <q-tooltip>
            Show this modifier set for items sold online.
          </q-tooltip>
        </model-form-checkbox>
        <model-form-checkbox
          field="multiselect"
          class="col-3 q-pb-md"
          label="Select Multiple"
        >
          <q-tooltip>
            Allow customers to select multiple modifiers from this set on a single item.
          </q-tooltip>
        </model-form-checkbox>
      </div>
      <modifier-table
        :modifier-set="modifierSet"
      />
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import ModifierTable from 'src/modules/admin/modifier-set/ModifierTable'

export default {
  name: 'ModifierSetForm',
  components: {
    ModelForm,
    ModifierTable
  },
  models: {
    modifierSet: {
      modifiers: {
        disableEditCostCents: true,
        inventoryAvailabilitiesAndConstraintsByLocationAndRegisterStation: true,
        inventoryRecipes: 'default',
        locations: 'default',
        libraryParentId: true,
        receiveLibraryUpdates: true
      },
      editing: true,
      libraryDescendantSites: true,
      libraryChildSiteIds: true
    }
  }
}

</script>
